
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/about-the-lab",
      function () {
        return require("private-next-pages/material-ui/about-the-lab.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/about-the-lab"])
      });
    }
  